import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function pluralize(count: number, singular: string, plural?: string) {
  if (count === 1) return singular;

  const defaultPlural = singular.endsWith("y")
    ? singular.slice(0, -1) + "ies"
    : singular + "s";

  return plural ?? defaultPlural;
}

export function formatByteSize(
  bytes: number | null | undefined
): string | null {
  if (bytes == null || bytes === 0) return null;
  const units = ["B", "KB", "MB", "GB"];
  let value = bytes;
  let unitIndex = 0;
  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }
  const formatted =
    unitIndex === 0 ? String(Math.round(value)) : value.toFixed(1);
  return `${formatted} ${units[unitIndex]}`;
}
